import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, update } from "firebase/database";
import { initializeApp, getApps } from "firebase/app";
import { useNavigate } from "react-router-dom";
import { app } from "./firebase";

function AddVendeurPage({ uid }) {
  const navigate = useNavigate();

  // 🔑 إنشاء App ثانوي (Secondary App)
  const secondaryApp =
    getApps().find((a) => a.name === "Secondary") ||
    initializeApp(app.options, "Secondary");

  const secondaryAuth = getAuth(secondaryApp);
  const db = getDatabase();

  // 🧾 form state
  const [form, setForm] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });

  // ⏳ loading state
  const [loading, setLoading] = useState(false);

  const createVendeur = async () => {
    const { name, lastName, email, phone, password } = form;

    if (!name || !lastName || !email || !password) {
      alert("❌ الحقول مطلوبة");
      return;
    }

    try {
      setLoading(true);

      // 1️⃣ إنشاء حساب Auth للبائع بدون تسجيل خروج
      const cred = await createUserWithEmailAndPassword(
        secondaryAuth,
        email,
        password
      );

      const vendeurId = cred.user.uid;

      // 2️⃣ حفظ في users
      await update(ref(db), {
        [`users/${vendeurId}`]: {
          userId: vendeurId,
          userType: "vendeur",
          name,
          lastName,
          email,
          phone,
          active: true,
          emailVerifiedRequired: false,
          createdAt: Date.now(),
        },
      });

      // 3️⃣ ربط البائع بالموزع
      await update(ref(db), {
        [`distributors/${uid}/vendeurs/${vendeurId}`]: {
          vendeurId,
          name,
          lastName,
          email,
          phone,
          active: true,
          emailVerifiedRequired: false,
          canEdit: false,
          createdAt: Date.now(),
        },
      });

      alert("✅compte de vendeur crée");
      navigate("/vendeurs");
    } catch (error) {
      alert("❌ " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const labelStyle = {
  fontSize: 14,
  fontWeight: 500,
  marginBottom: 4,
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: 10,
  marginBottom: 12,
  borderRadius: 6,
  border: "1px solid #ccc",
};


 return (
  <div style={{ maxWidth: 400, margin: "auto" }}>
    <h2 style={{ textAlign: "center" }}>➕ Créer un vendeur</h2>

    {/* Nom */}
    <label style={labelStyle}>Nom</label>
    <input
      value={form.name}
      onChange={(e) => setForm({ ...form, name: e.target.value })}
      style={inputStyle}
    />

    {/* Prénom */}
    <label style={labelStyle}>Prénom</label>
    <input
      value={form.lastName}
      onChange={(e) => setForm({ ...form, lastName: e.target.value })}
      style={inputStyle}
    />
    {/* Téléphone */}
    <label style={labelStyle}>Téléphone</label>
    <input
      value={form.phone}
      onChange={(e) => setForm({ ...form, phone: e.target.value })}
      style={inputStyle}
    />

    {/* Email */}
    <label style={labelStyle}>Email</label>
    <input
      type="email"
      value={form.email}
      onChange={(e) => setForm({ ...form, email: e.target.value })}
      style={inputStyle}
    />

    

    {/* Mot de passe */}
    <label style={labelStyle}>Mot de passe</label>
    <input
      type="password"
      value={form.password}
      onChange={(e) => setForm({ ...form, password: e.target.value })}
      style={inputStyle}
    />

    <button
      onClick={createVendeur}
      disabled={loading}
      style={{
        width: "100%",
        padding: 12,
        background: loading ? "#94a3b8" : "#2563eb",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        cursor: loading ? "not-allowed" : "pointer",
        marginTop: 10,
      }}
    >
      {loading ? "⏳ création en cours..." : "Créer"}
    </button>
  </div>
);

}

export default AddVendeurPage;
